function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Chevron from "../icon-components/chevron";
import Button from "../components/button";

var DropdownToggle = function DropdownToggle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      bsClass = _ref.bsClass,
      title = _ref.title,
      withCaret = _ref.withCaret,
      bsRole = _ref.bsRole,
      props = _objectWithoutProperties(_ref, ["children", "className", "bsClass", "title", "withCaret", "bsRole"]);

  return React.createElement(Button, _extends({}, props, {
    className: cx(className, bsClass)
  }), children || title, withCaret ? React.createElement("span", null, ' ', React.createElement(Chevron, null)) : null);
};

DropdownToggle.displayName = 'DropdownToggle';
DropdownToggle.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  bsClass: PropTypes.string,
  title: PropTypes.string,
  bsRole: PropTypes.string,
  withCaret: PropTypes.bool
};
export default DropdownToggle;